import React, { useEffect } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./YourStory.css";
import { useNavigate } from "react-router-dom";

const YourStory = () => {
  const navigate = useNavigate();
  return (
    <>
      <section className="yellow_bg story-section">
        <div className="container">
          <div className="story-heading">
            <span>🐾 YOUR STORY</span>
            <h2>Real Stories. Real Pets. Real People.</h2>

            <p>
              Explore inspiring podcasts, heartwarming member stories, and
              testimonials from pet lovers across India.
            </p>
          </div>
          <div className="row">
          <div className="col-lg-4">
            <div className="story-card">
              <div className="story-icon">🎙</div>

              <div className="story-image">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/imgs/video_poster.jpg`}
                  alt=""
                />

                <div className="story-overlay">
                  <i className="fas fa-play"></i>
                </div>
              </div>

              <div className="story-content">
                <span className="story-tag podcast">Podcast</span>

                <h4>Pet Parenting with Experts</h4>

                <p>
                  Watch inspiring conversations with veterinarians, trainers and
                  experienced pet parents.
                </p>

                <button className="story-btn">
                  Watch Podcast
                  <i className="fas fa-arrow-right ms-2"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="story-card">
              <div className="story-icon">📖</div>

              <div className="story-image">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/imgs/video_poster.jpg`}
                  alt="Member Story"
                />
              </div>

              <div className="story-content">
                <span className="story-tag member">Member Story</span>

                <h4>Bella's Journey Home</h4>

                <p>
                  Discover how Bella, a rescued Indie dog, found her forever
                  family through love, care, and compassion.
                </p>

                <button className="story-btn">
                  Read Story
                  <i className="fas fa-arrow-right ms-2"></i>
                </button>
              </div>
            </div>
          </div>

          <div className="col-lg-4">
            <div className="story-card">
              <div className="story-icon">⭐</div>

              <div className="story-image">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/imgs/video_poster.jpg`}
                  alt="Testimonial"
                />
              </div>

              <div className="story-content">
                <span className="story-tag review">Testimonial</span>

                <h4>Avinash Agarwal</h4>

                <p>
                  Hear firsthand how Everything Pawzible helped create a
                  trusted, supportive community for pet parents across India.
                </p>

                <button className="story-btn">
                  Watch Testimonial
                  <i className="fas fa-arrow-right ms-2"></i>
                </button>
              </div>
            </div>
          </div>
          

          </div>
        </div>
      </section>
    </>
  );
};

export default YourStory;
